var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x92\x8E Icon=ExpandCollapse Sidemenu, Stroke=1.5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 7.58579 4.33579 7.25 4.75 7.25L7.75 7.25C8.16421 7.25 8.5 7.58579 8.5 8C8.5 8.41422 8.16421 8.75 7.75 8.75L4.75 8.75C4.33579 8.75 4 8.41421 4 8Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 10.25C4.33579 10.25 4 10.5858 4 11C4 11.4142 4.33579 11.75 4.75 11.75H7.75C8.16421 11.75 8.5 11.4142 8.5 11C8.5 10.5858 8.16421 10.25 7.75 10.25L4.75 10.25Z",
    className: "Icon-fill-color"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 18C1.25 19.5188 2.48122 20.75 4 20.75H20C21.5188 20.75 22.75 19.5188 22.75 18V6C22.75 4.48122 21.5188 3.25 20 3.25H4C2.48122 3.25 1.25 4.48122 1.25 6V18ZM4 19.25C3.30964 19.25 2.75 18.6904 2.75 18L2.75 6C2.75 5.30964 3.30964 4.75 4 4.75L9.5 4.75L9.5 19.25H4ZM11 19.25L20 19.25C20.6904 19.25 21.25 18.6904 21.25 18V6C21.25 5.30964 20.6904 4.75 20 4.75L11 4.75L11 19.25Z",
    className: "Icon-fill-color"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideMenu);
export default __webpack_public_path__ + "static/media/SideMenu.422bb0f107a0316ce82a4035384005e4.svg";
export { ForwardRef as ReactComponent };